import {
    ToggleNotificationRequest,
    ToggleNotificationResponse,
} from '../../type/NotificationType'
import EcService from '../ec.service'

class CustomerNotificationService extends EcService {
    public toggleNotification(params: ToggleNotificationRequest) {
        return new Promise<ToggleNotificationResponse>((resolve, reject) => {
            this.client
                .post('ToggleNotification', params)
                .then((response) => {
                    resolve(response.data.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}

export default new CustomerNotificationService()
